import React from 'react';
// import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
// import PublishIcon from '@mui/icons-material/Publish';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
// import GetAppIcon from '@mui/icons-material/GetApp';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import InfoOutlined from '@mui/icons-material/InfoOutlined';
// import Printicon from '@mui/icons-material/Print';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import {
// Box,
// Tab,
} from '@mui/material';
import {
// TabContext,
// TabList,
// TabPanel,
} from '@mui/lab';

import {
  FlexGridColumnGroup,
  // FlexGridCellTemplate
} from '@grapecity/wijmo.react.grid';

import {
// createTyohyoPdf,
// getCodeFromGeneralPurposeMap,
// changeDateFormat,
// getErrorCode,
// API_CODE,
// getErrorMessages,
// getResponseResult,
// getDataFromGeneralPurposeMap,
// getMaxDeleteNum
} from '../../../../common/common.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
import MainContainer from '../../../organisms/MainContainer.js';
import {renderSelect} from '../../../atoms/CustomPart.js';
// import {createSearchList} from '../../../../../common/ComboParts.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
// import MuiTooltip from '../../../../atoms/MuiTooltip.js';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
// import DangerButton from '../../..//atoms/Buttons/DangerButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
// import KyogaCompanyInfo from '../../../../molecules/KyogaCompanyInformation.js';
// import * as validateRule from '../../../validateRule.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
// import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';
// import {setSessionObject} from '../../../../common/Session.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
// import SaveIcon from '@mui/icons-material/Save';
// import CheckCircle from '@mui/icons-material/CheckCircle';
// import Cancel from '@mui/icons-material/Cancel';
// import DangerButton from '../../../atoms/Buttons/DangerButton.js';
import {CellType} from '@grapecity/wijmo.grid';
import CustomAccordion from '../../../molecules/Accordion.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.TSTK_PROGRESS_MONTH_KOTEI_LIST.name, href: ''},
];

const styles = (theme) => ({

});

// 調査月度別進捗
const tsMonthViews = [
  {binding: 'tsMonthBt1', header: '月度', dataType: 'String', width: 80, readOnly: true},
  {binding: 'tsMonthBt2', header: '月度', dataType: 'String', width: 105, readOnly: true},
  {header: '2026年', dataType: 'header', elems: [
    {binding: 'tsMonth4', header: '4月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tsMonth5', header: '5月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tsMonth6', header: '6月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tsMonth7', header: '7月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tsMonth8', header: '8月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tsMonth9', header: '9月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tsMonth10', header: '10月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tsMonth11', header: '11月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tsMonth12', header: '12月', dataType: 'Number', width: 89, readOnly: true},
  ]},
  {header: '2027年', dataType: 'header', elems: [
    {binding: 'tsMonth1', header: '1月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tsMonth2', header: '2月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tsMonth3', header: '3月', dataType: 'Number', width: 89, readOnly: true},
  ]},
  {binding: 'tsGoukei', header: '合計', dataType: 'String', width: 89, readOnly: false, align: 'right'},
];

// 調査工程別進捗
const tsKoteiViews = [
  {binding: 'tsStatus10', header: '未着手', dataType: 'Number', width: 120, readOnly: true},
  {binding: 'tsStatus20', header: '調査中', dataType: 'Number', width: 120, readOnly: true},
  {binding: 'tsStatus30', header: '調査済', dataType: 'Number', width: 120, readOnly: true},
  {binding: 'tsStatus40', header: '報告中', dataType: 'Number', width: 120, readOnly: true},
  {binding: 'tsStatus60', header: '承認中', dataType: 'Number', width: 120, readOnly: true},
  {binding: 'tsStatus90', header: '完了', dataType: 'Number', width: 120, readOnly: true},
];

// 点検月度別進捗
const tkMonthViews = [
  {binding: 'tkMonthBt1', header: '月度', dataType: 'String', width: 80, readOnly: true},
  {binding: 'tkMonthBt2', header: '月度', dataType: 'String', width: 105, readOnly: true},
  {header: '2026年', dataType: 'header', elems: [
    {binding: 'tkMonth4', header: '4月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tkMonth5', header: '5月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tkMonth6', header: '6月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tkMonth7', header: '7月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tkMonth8', header: '8月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tkMonth9', header: '9月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tkMonth10', header: '10月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tkMonth11', header: '11月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tkMonth12', header: '12月', dataType: 'Number', width: 89, readOnly: true},
  ]},
  {header: '2027年', dataType: 'header', elems: [
    {binding: 'tkMonth1', header: '1月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tkMonth2', header: '2月', dataType: 'Number', width: 89, readOnly: true},
    {binding: 'tkMonth3', header: '3月', dataType: 'Number', width: 89, readOnly: true},
  ]},
  {binding: 'tkGoukei', header: '合計', dataType: 'String', width: 89, readOnly: false, align: 'right'},
];

// 点検工程別進捗
const tkKoteiViews = [
  {binding: 'tkStatus10', header: '未着手', dataType: 'Number', width: 120, readOnly: true},
  {binding: 'tkStatus20', header: '点検中', dataType: 'Number', width: 120, readOnly: true},
  {binding: 'tkStatus30', header: '点検済', dataType: 'Number', width: 120, readOnly: true},
  {binding: 'tkStatus40', header: '報告中', dataType: 'Number', width: 120, readOnly: true},
  {binding: 'tkStatus50', header: '確認中', dataType: 'Number', width: 120, readOnly: true},
  {binding: 'tkStatus60', header: '承認中', dataType: 'Number', width: 120, readOnly: true},
  {binding: 'tkStatus90', header: '完了', dataType: 'Number', width: 120, readOnly: true},
];

/**
 * 調査・点検進捗状況照会(月別・工程別)画面
 * 画面ID:SCE1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      warningMessages: [],
    };

    this.gridRef = React.createRef();
    this.gridRefTsKotei = React.createRef();
    this.gridRefTkMonth = React.createRef();
    this.gridRefTkKotei = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef && this.gridRef.current) {
        // this.gridRef.current.setInitItems('1001', []);
      }
      let headerData = {zigyoujo: 5160, surveyYear: ''};
      headerData['zigyoujo'] = '5160';
      headerData['surveyYear'] = '1';
      this.props.doSetInitValues(headerData);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.saveScreenState('1001', 'Id');
    //   this.gridRef.current.setItems(null);
    // }
  }

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    const data =[
      {tsMonthBt1: '予定件数', tsMonthBt2: '月別（件）', tsMonth4: '8,770', tsMonth5: '31,630', tsMonth6: '47,030', tsMonth7: '38,260', tsMonth8: '42,710', tsMonth9: '50,010', tsMonth10: '47,310', tsMonth11: '38,280', tsMonth12: '48,930', tsMonth1: '33,610', tsMonth2: '28,270', tsMonth3: '40,690', tsGoukei: '455,500'},
      {tsMonthBt1: '予定件数', tsMonthBt2: '進捗率（％）', tsMonth4: '1', tsMonth5: '8', tsMonth6: '19', tsMonth7: '27', tsMonth8: '38', tsMonth9: '47', tsMonth10: '58', tsMonth11: '66', tsMonth12: '77', tsMonth1: '84', tsMonth2: '91', tsMonth3: '100', tsGoukei: '-'},
      {tsMonthBt1: '実績件数', tsMonthBt2: '月別（件）', tsMonth4: '11,830', tsMonth5: '20,960', tsMonth6: '51,720', tsMonth7: '45,380', tsMonth8: '40,430', tsMonth9: '42,790', tsMonth10: '48,270', tsMonth11: '42,980', tsMonth12: '58520', tsMonth1: '34,560', tsMonth2: '44,260', tsMonth3: '13,720', tsGoukei: '450,520'},
      {tsMonthBt1: '実績件数', tsMonthBt2: '進捗率（％）', tsMonth4: '2', tsMonth5: '7', tsMonth6: '18', tsMonth7: '28', tsMonth8: '37', tsMonth9: '46', tsMonth10: '57', tsMonth11: '66', tsMonth12: '78', tsMonth1: '87', tsMonth2: '96', tsMonth3: '99', tsGoukei: '-'},
      {tsMonthBt1: '実績件数', tsMonthBt2: '再調査（件）', tsMonth4: '1', tsMonth5: '2', tsMonth6: '3', tsMonth7: '3', tsMonth8: '4', tsMonth9: '4', tsMonth10: '1', tsMonth11: '1', tsMonth12: '2', tsMonth1: '2', tsMonth2: '2', tsMonth3: '3', tsGoukei: '28'},

    ];
    const tsKoteiData=[
      {tsStatus10: '9,999,999', tsStatus20: '9,999,999', tsStatus30: '9,999,999', tsStatus40: '9,999,999', tsStatus03: '9,999,999', tsStatus60: '9,999,999', tsStatus90: '9,999,999'},
    ];

    const tkMonthData =[
      {tkMonthBt1: '予定件数', tkMonthBt2: '月別（件）', tkMonth4: '8,770', tkMonth5: '31,630', tkMonth6: '47,030', tkMonth7: '38,260', tkMonth8: '42,710', tkMonth9: '50,010', tkMonth10: '47,310', tkMonth11: '38,280', tkMonth12: '48,930', tkMonth1: '33,610', tkMonth2: '28,270', tkMonth3: '40,690', tkGoukei: '455,500'},
      {tkMonthBt1: '予定件数', tkMonthBt2: '進捗率（％）', tkMonth4: '1', tkMonth5: '8', tkMonth6: '19', tkMonth7: '27', tkMonth8: '38', tkMonth9: '47', tkMonth10: '58', tkMonth11: '66', tkMonth12: '77', tkMonth1: '84', tkMonth2: '91', tkMonth3: '100', tkGoukei: '-'},
      {tkMonthBt1: '実績件数', tkMonthBt2: '月別（件）', tkMonth4: '11,830', tkMonth5: '20,960', tkMonth6: '51,720', tkMonth7: '45,380', tkMonth8: '40,430', tkMonth9: '42,790', tkMonth10: '48,270', tkMonth11: '42,980', tkMonth12: '58520', tkMonth1: '34,560', tkMonth2: '44,260', tkMonth3: '13,720', tkGoukei: '450,520'},
      {tkMonthBt1: '実績件数', tkMonthBt2: '進捗率（％）', tkMonth4: '2', tkMonth5: '7', tkMonth6: '18', tkMonth7: '28', tkMonth8: '37', tkMonth9: '46', tkMonth10: '57', tkMonth11: '66', tkMonth12: '78', tkMonth1: '87', tkMonth2: '96', tkMonth3: '99', tkGoukei: '-'},
      {tkMonthBt1: '実績件数', tkMonthBt2: '不良（件）', tkMonth4: '1', tkMonth5: '1', tkMonth6: '1', tkMonth7: '1', tkMonth8: '1', tkMonth9: '2', tkMonth10: '2', tkMonth11: '2', tkMonth12: '2', tkMonth1: '2', tkMonth2: '2', tkMonth3: '2', tkGoukei: '19'},

    ];
    const tkKoteiData=[
      {tkStatus10: '9,999,999', tkStatus20: '9,999,999', tkStatus30: '9,999,999', tkStatus40: '9,999,999', tkStatus50: '9,999,999', tkStatus60: '9,999,999', tkStatus90: '9,999,999'},
    ];


    this.gridRef.current.setItemsSource(data);
    this.gridRefTsKotei.current.setItemsSource(tsKoteiData);
    this.gridRefTkMonth.current.setItemsSource(tkMonthData);
    this.gridRefTkKotei.current.setItemsSource(tkKoteiData);
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    const data =[];
    this.gridRef.current.setItemsSource(data);
    this.gridRefTsKotei.current.setItemsSource(data);
    this.gridRefTkMonth.current.setItemsSource(data);
    this.gridRefTkKotei.current.setItemsSource(data);
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * セル結合をカスタム
   * @param {object} wjgGrid wijmo.grid モジュール
   * @param {object} panel 範囲を含むGridPanel
   * @param {number} r セルが含まれる行のインデックス
   * @param {number} c セルが含まれる列のインデックス
   * @param {boolan} clip 結合範囲をグリッドの現在のビュー範囲にクリップするかどうか
   * @return {*} 結合範囲を指定するCellRange
   */
  mergedRange = (wjgGrid, panel, r, c, clip = true) => {
    let rng = new wjgGrid.CellRange(r, c);
    const yearBindingsTsKo = [
      'tsMonth4', 'tsMonth5', 'tsMonth6', 'tsMonth7', 'tsMonth8', 'tsMonth9',
      'tsMonth10', 'tsMonth11', 'tsMonth12',
    ];
    const yearBindingsTsRi = [
      'tsMonth1', 'tsMonth2', 'tsMonth3',
    ];
    const yearBindingstkKo = [
      'tkMonth4', 'tkMonth5', 'tkMonth6', 'tkMonth7', 'tkMonth8', 'tkMonth9',
      'tkMonth10', 'tkMonth11', 'tkMonth12',
    ];
    const yearBindingstkRi = [
      'tkMonth1', 'tkMonth2', 'tkMonth3',
    ];
    if (panel.cellType == CellType.ColumnHeader) {
      // 調査月度のヘッダの合併
      if (['tsMonthBt1', 'tsMonthBt2'].includes(panel.columns.at(c).binding)) {
        rng.col = 0;
        rng.col2 = 1;
        rng.row = 0;
        rng.row2 = 1;
        return rng;
      }
      // 点検月度のヘッダの合併
      if (['tkMonthBt1', 'tkMonthBt2'].includes(panel.columns.at(c).binding)) {
        rng.col = 0;
        rng.col2 = 1;
        rng.row = 0;
        rng.row2 = 1;
        return rng;
      }
      // 調査月度の4月～12月の年度のヘッダの合併
      if (r == 0 && yearBindingsTsKo.includes(panel.columns.at(c).binding)) {
        rng.col = 2;
        rng.col2 = 10;
        return rng;
      }
      // 調査月度の１月～３月の年度のヘッダの合併
      if (r == 0 && yearBindingsTsRi.includes(panel.columns.at(c).binding)) {
        rng.col = 11;
        rng.col2 = 13;
        return rng;
      }
      // 点検月度の4月～12月の年度のヘッダの合併
      if (r == 0 && yearBindingstkKo.includes(panel.columns.at(c).binding)) {
        rng.col = 2;
        rng.col2 = 10;
        return rng;
      }
      // 点検月度の１月～３月の年度のヘッダの合併
      if (r == 0 && yearBindingstkRi.includes(panel.columns.at(c).binding)) {
        rng.col = 11;
        rng.col2 = 13;
        return rng;
      }


      if (['tsGoukei'].includes(panel.columns.at(c).binding)) {
        rng.row = 0;
        rng.row2 = 1;
        return rng;
      }
      if (['tkGoukei'].includes(panel.columns.at(c).binding)) {
        rng.row = 0;
        rng.row2 = 1;
        return rng;
      }
    }

    if (panel.cellType == CellType.Cell) {
      if (c < 2) {
        let pcol = c > 0 ? c - 1 : c;
        let pval = panel.getCellData(r, pcol, false);
        let val = panel.getCellData(r, c, false);

        // 縦結合（up）※現行と前行の列が一致
        while (rng.row > 0 &&
          panel.getCellData(rng.row - 1, c, false) == val &&
          panel.getCellData(rng.row - 1, pcol, false) == pval) {
          rng.row--;
        }
        // 縦結合（down）※現行と前行のが一致
        while (rng.row2 < panel.rows.length - 1 &&
          panel.getCellData(rng.row2 + 1, c, false) == val &&
          panel.getCellData(rng.row2 + 1, pcol, false) == pval) {
          rng.row2++;
        }
        // 横結合
        const data = panel.rows[r].dataItem;
        if (data.syokeiMerge) {
          rng.col = 0;
          rng.col2 = 1;
        }
      } else {

      }
    }
    return rng;
  };

  doConfirm = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['確認'],
      },
    });
  };


  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      // cssClass='bf-gray-background'
      align={view.align}
      isReadOnly={view.readOnly}/>;
  };

  /**
   * 項目フォーマット処理
   *
   * @param {object} s sender
   * @param {string} e event
   */
  formatItemFunction = (s, e) => {
    // 行が存在しない場合は終了
    const rows = s.rows;
    if (rows.length == 0) {
      return;
    }
    if (e.panel.cellType == CellType.Cell) {
      e.cell.style.backgroundColor = '';
      // ReadOnlyのセルか？
      // if (e.cell.ariaReadOnly) {
      //   e.cell.style.backgroundColor = '#e6e6fa';
      // }
    }
    if (e.panel.cellType == CellType.Cell) {
      const col = e.getColumn();
      const data = s.rows[e.row].dataItem;
      if (col && ((col.binding === 'sinnseiStatus' &&
        data.hiKetuFlag === '1') )) {
        // e.cell.style.backgroundColor = '#fff0f5';
        e.cell.style.backgroundColor = '#ff0000';
      }
    }
  };

  /**
   * 調査工程別状況
   * @return {*}
   */
  renderTableTsKotei() {
    const props = {
      rowHeaderType: 'none',
      id: 'SCE1002HenkomaeTable',
      filterOn: false,
      allowSorting: 'None',
      headersVisibility: 'Column',
      allowDragging: 'Columns',
      style: {height: 'auto', maxHeight: 'auto', maxWidth: 'auto', width: 'auto'},
      isReadOnly: false,
      screenId: 'SCE1002Henkomae',
      checkedFunction: this.checkStateUpdate,
      doShowMessage: this.props.doShowMessage,
      validateEdits: false,
      getError: this.getError,

    };
    // 一覧定義取得
    let viewElems = [];
    if (tsKoteiViews) {
      for (const view of tsKoteiViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRefTsKotei} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * 調査月別状況
   * @return {object}
   */
  renderTableTsMonth() {
    const props = {
      rowHeaderType: 'none',
      filterOn: false,
      allowSorting: 'None',
      headersVisibility: 'Column',
      allowDragging: 'None',
      AddDeleteOn: false,
      style: {maxHeight: 'auto', maxWidth: 'auto', height: 'auto', width: 'auto'},
      isReadOnly: true,
      checkedFunction: this.checkStateUpdate,
      formatItemFunction: this.formatItemFunction,
      customMergedRange: this.mergedRange,
    };

    let viewElems = [];
    if (tsMonthViews) {
      for (const view of tsMonthViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }
  /**
   * 点検工程別状況
   * @return {*}
   */
  renderTableTkKotei() {
    const props = {
      rowHeaderType: 'none',
      id: 'SCE1002HenkomaeTable',
      filterOn: false,
      allowSorting: 'None',
      headersVisibility: 'Column',
      allowDragging: 'Columns',
      style: {height: 'auto', maxHeight: 'auto', maxWidth: 'auto', width: 'auto'},
      isReadOnly: false,
      screenId: 'SCE1002Henkomae',
      checkedFunction: this.checkStateUpdate,
      doShowMessage: this.props.doShowMessage,
      validateEdits: false,
      getError: this.getError,

    };
    // 一覧定義取得
    let viewElems = [];
    if (tkKoteiViews) {
      for (const view of tkKoteiViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRefTkKotei} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * 点検月別状況
   * @return {object}
   */
  renderTableTkMonth() {
    const props = {
      rowHeaderType: 'none',
      filterOn: false,
      allowSorting: 'None',
      headersVisibility: 'Column',
      allowDragging: 'None',
      AddDeleteOn: false,
      style: {maxHeight: 'auto', maxWidth: 'auto', height: 'auto', width: 'auto'},
      isReadOnly: true,
      checkedFunction: this.checkStateUpdate,
      formatItemFunction: this.formatItemFunction,
      customMergedRange: this.mergedRange,
    };

    let viewElems = [];
    if (tkMonthViews) {
      for (const view of tkMonthViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRefTkMonth} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="surveyYear" item xs={12} sm={1}>
            <Field
              id="surveyYear"
              name="surveyYear"
              component={renderSelect}
              className="fields"
              label="年度"
              type="text"
              fullWidth
              required={true}
              // validate={[
              //   validateRule.number,
              //   validateRule.maxLength(4),
              // ]}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'2026'}</MenuItem>
              <MenuItem value={2}>{'2025'}</MenuItem>
              <MenuItem value={3}>{'2024'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="zigyoujo" item xs={12} sm={2}>
            <Field
              id="zigyoujo"
              name="zigyoujo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="NW事業所"
              type="text"
              fullWidth
              required={true}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
              <MenuItem value={6120}>{'山口'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="zigyoujoOld" item xs={12} sm={2}>
            <Field
              id="zigyoujoOld"
              name="zigyoujoOld"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="旧NW事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
              <MenuItem value={6120}>{'廿日市'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tyousakikan" item xs={12} sm={2}>
            <Field
              id="tyousakikan"
              name="tyousakikan"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査会社"
              type="text"
              fullWidth
              required={true}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={'0000'}>{'中電ＮＷ'}</MenuItem>
              <MenuItem value={3000}>{'保安協会'}</MenuItem>
              <MenuItem value={5000}>{'工業組合'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tskkJgyosyo" item xs={12} sm={2}>
            <Field
              id="tskkJgyosyo"
              name="tskkJgyosyo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査機関事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={4510}>{'福山支'}</MenuItem>
              <MenuItem value={4580}>{'府中支'}</MenuItem>

            </Field>
          </Grid>
          <Grid key="tsTkUserId" item xs={12} sm={2}>
            <Field
              id="tsTkUserId"
              name="tsTkUserId"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="担当者"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={'TB0001'}>{'田中　一郎'}</MenuItem>
              <MenuItem value={'TB0002'}>{'田中　二郎'}</MenuItem>

            </Field>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
      </Grid>
    );
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList}/>
          <Grid key="keySCA1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="search" item xs={12}>
                <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          {/* 調査状況 */}
          <Grid container
            justifyContent="left"
            alignItems="left"
            item xs={12} sm={6}
          >
            <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold', marginLeft: '5px'}}> 定期調査進捗状況照会</Typography>
          </Grid>
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-end"
          >
            <Grid container
              justifyContent="left"
              alignItems="left"
              item xs={12} sm={6}
            >
              <Typography variant="h8" gutterBottom sx={{marginLeft: '5px'}} >■月度別進捗</Typography>
            </Grid>
            <Grid container
              justifyContent="right"
              alignItems="right"
              item xs={12} sm={4}
            >
              <Typography variant="h8" gutterBottom sx={{marginRight: '0px'}} >(20日締め)</Typography>
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              direction={'row'}
            >
            </Grid>
            <Grid key="keySCA1002HenkomaeTable" item xs={12}>
              {this.renderTableTsMonth()}
            </Grid>
            <Grid container
              justifyContent="left"
              alignItems="left"
              item xs={12} sm={6}
            >
              <Typography variant="h8" gutterBottom sx={{marginLeft: '5px'}} >■工程別最新状況</Typography>
            </Grid>
            <Grid key="keySCA1002HenkomaeTable" item xs={12}>
              {this.renderTableTsKotei()}
            </Grid>

          </Grid>

          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />

          {/* 点検状況 */}
          <Grid container
            justifyContent="left"
            alignItems="left"
            item xs={12} sm={6}
          >
            <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold', marginLeft: '5px'}}> 引込線点検進捗状況照会</Typography>
          </Grid>
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-end"
          >
            <Grid container
              justifyContent="left"
              alignItems="left"
              item xs={12} sm={6}
            >
              <Typography variant="h8" gutterBottom sx={{marginLeft: '5px'}} >■月度別進捗</Typography>
            </Grid>
            <Grid container
              justifyContent="right"
              alignItems="right"
              item xs={12} sm={4}
            >
              <Typography variant="h8" gutterBottom sx={{marginRight: '0px'}} >(20日締め)</Typography>
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              direction={'row'}
            >
            </Grid>
            <Grid key="keySCA1002HenkomaeTable" item xs={12}>
              {this.renderTableTkMonth()}
            </Grid>
            <Grid container
              justifyContent="left"
              alignItems="left"
              item xs={12} sm={6}
            >
              <Typography variant="h8" gutterBottom sx={{marginLeft: '5px'}} >■工程別最新状況</Typography>
            </Grid>
            <Grid key="keySCA1002HenkomaeTable" item xs={12}>
              {this.renderTableTkKotei()}
            </Grid>

          </Grid>
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    initialValues: {
      surveyYear: '1',
      zigyoujo: '5160',
      tyousakikan: '0000',
      itakuArea: '0',
      // tyousakikan: '保安協会',
    },
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);

